import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, message, Tooltip } from "antd";
import { FaFileExport } from "react-icons/fa";

export default function ExportParticipantesExcel({ getData }) {
  const handleExport = async () => {
    message.loading("Generando Excel...", 0);
    const data = await getData();
    if (!data || data.length === 0) {
      message.destroy();
      message.warning("No hay datos para exportar");
      return;
    }
    message.destroy();
    try {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = "Sistema Participantes";
      workbook.created = new Date();
      const worksheet = workbook.addWorksheet("Participantes");
      worksheet.mergeCells("A1:K1");
      const titleCell = worksheet.getCell("A1");
      titleCell.value = "REPORTE GENERAL DE PARTICIPANTES";
      titleCell.font = { size: 18, bold: true, color: { argb: "FF111827" } };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      worksheet.getRow(1).height = 35;
      worksheet.mergeCells("A2:K2");
      const infoCell = worksheet.getCell("A2");
      infoCell.value = `Generado el: ${new Date().toLocaleString()}  |  Total registros: ${data.length}`;
      infoCell.font = { size: 11, italic: true };
      infoCell.alignment = { horizontal: "center" };
      worksheet.addRow([]);
      const headers = [
  "#",
  "Nombre Completo",
  "Identificación",
  "Género",
  "Departamento",
  "Municipio",
  "Teléfonos",
  "Dirección",
  "Correo",
  "Encuestador",
  "Estado Validación"
];

      const headerRow = worksheet.addRow(headers);
      headerRow.height = 25;
      headerRow.eachCell((cell) => {
        cell.font = {
          bold: true,
          size: 12,
          color: { argb: "FFFFFFFF" }
        };
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
          wrapText: true
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "02172F" }
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
      });
      worksheet.autoFilter = { from: "A4", to: "K4" };
      worksheet.views = [{ state: "frozen", ySplit: 4 }];
      data.forEach((p, index) => {
        const row = worksheet.addRow([
  index + 1,
  `${p.nombres || ""} ${p.apellidos || ""}`,
  p.num_identificacion || "",
  p.genero_nombre || "",
  p.departamento || "",
  p.municipio || "",

  // 👇 NUEVOS CAMPOS FORMATEADOS
  p.telefonos_exc || "",
  p.direcciones_exc || "",
  p.correos_exc || "",

  p.promotor_asignado || "Sin asignar",
  p.estado_validacion_nombre || ""
]);
        if (index % 2 === 0) {
          row.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFF9FAFB" }
            };
          });
        }
        row.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.alignment = { horizontal: "center" };
          }
          if ([3, 7, 9].includes(colNumber)) {
  cell.numFmt = "@";
}
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
        });
        const estadoCell = row.getCell(11);
        if (estadoCell.value === "Verificado") {
          estadoCell.font = { color: { argb: "FF009728" }, bold: true };
        }
        if (estadoCell.value === "En Proceso") {
          estadoCell.font = { color: { argb: "FF0968C6" }, bold: true };
        }
        if (estadoCell.value === "No Continúa") {
          estadoCell.font = { color: { argb: "FFB40000" }, bold: true };
        }
      });
      worksheet.columns.forEach((column, index) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const value = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, value.length);
        });
        if (index === 0) {
          column.width = 6; // #
        } else {
          column.width = Math.min(Math.max(maxLength + 2, 12), 35);
        }
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      saveAs(blob, "reporte_participantes.xlsx");
      message.success("Excel exportado correctamente");
    } catch (error) {
      console.error(error);
      message.error("Error exportando Excel");
    }
  };

  return (
    <Tooltip title="Exportar a Excel">
      <Button
        icon={<FaFileExport />}
        onClick={handleExport}
        style={{
          backgroundColor: "#009728",
          color: "#fff",
          height: 45,
          width: 140,
          fontWeight: 600
        }}
      >
        Exportar Excel
      </Button>
    </Tooltip>
  );
}
